import { DateTime } from 'luxon';

/* eslint-disable import/prefer-default-export */
const removeEnclosingSingleQuotes = (str: string): string => str.replace(/^'([^']+(?='))'$/g, '$1');

const removeEnclosingDoubleQuotes = (str: string): string => str.replace(/^"([^"]+(?="))"$/g, '$1');

const removeEnclosingQuotes = (str: string): string => {
  if (str.charAt(0) === '"') {
    return removeEnclosingDoubleQuotes(str);
  } if (str.charAt(0) === "'") {
    return removeEnclosingSingleQuotes(str);
  }
  return str;
};

const attributeRegEx = /^({{)(.*?)(}})$/g;
const listRegEx = /^(\[)(.*?)(\])$/g;
const channelRegEx = /^(%%)(.*?)(%%)$/g;
const functionRegEx = /([a-zA-Z0-9]+)\(([^)]*)\)/;
const functionRegExGlobal = /([a-zA-Z0-9]+)\(([^)]*)\)/g;
const functionArgumentsRegEx = /\(([^)]*)\)/;
const functionArgumentSplitingRegEx = /(?![^)(]*\([^)(]*?\)\)),(?![^[]*\])/;

const operatorRegexStr = '\\s+in\\s+|==|!=|<=|<|>=|>';
const operatorRegEx = new RegExp(operatorRegexStr, 'i');
const functionWithSpacesRegEx = /^\s*([a-z0-9]+)\s*\(([^)]*)\)\s*$/i;

const andOperatorRegexStr = '\\s+AND\\s+(?=[^"\']*(?:["\'][^"\']*["\'][^"\']*)*$)';
const orOperatorRegexStr = '\\s+OR\\s+(?=[^"\']*(?:["\'][^"\']*["\'][^"\']*)*$)';
const notOperatorRegexStr = '\\s+NOT\\s+(?=[^"\']*(?:["\'][^"\']*["\'][^"\']*)*$)';
const inOperatorRegexStr = '\\s+IN\\s+(?=[^"\']*(?:["\'][^"\']*["\'][^"\']*)*$)';
const andOperatorRegEx = new RegExp(andOperatorRegexStr, 'gi');
const orOperatorRegEx = new RegExp(orOperatorRegexStr, 'gi');
const notOperatorRegEx = new RegExp(notOperatorRegexStr, 'gi');
const inOperatorRegEx = new RegExp(inOperatorRegexStr, 'gi');

const variableIndexRegEx = /^\$([tv]:\d+)\$$/;

const ANALYTICS_TIME_INTERVAL = '30d';

const timeIntervalToStartDate: { [key: string]: () => string } = {
  [ANALYTICS_TIME_INTERVAL]: () => DateTime.utc().minus({ days: 30 }).toFormat('yyyy-MM-dd'),
};

export {
  removeEnclosingQuotes,
  attributeRegEx,
  listRegEx,
  channelRegEx,
  functionRegEx,
  functionRegExGlobal,
  functionArgumentsRegEx,
  functionArgumentSplitingRegEx,
  operatorRegEx,
  functionWithSpacesRegEx,
  andOperatorRegEx,
  orOperatorRegEx,
  notOperatorRegEx,
  inOperatorRegEx,
  variableIndexRegEx,
  ANALYTICS_TIME_INTERVAL,
  timeIntervalToStartDate,
};
